import type { FC } from "react";

import { A11yMenu } from "@aviary";
import { useBreakpoints } from "@shared/hooks";

import { OpenCatalogNavigation } from "./OpenCatalogNavigation";
import { OpenMobileNavigation } from "./OpenMobileNavigation";

const PageHeader: FC = () => {
  const { tablet } = useBreakpoints();

  return (
    <>
      <A11yMenu />
      {tablet.lessThan ? <OpenMobileNavigation /> : <OpenCatalogNavigation />}
    </>
  );
};

export { PageHeader };
